/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyday & Measure`)
};

const es_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Día a Día y Medidas`)
};

const de_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alltag & Messen`)
};

const nl_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijks & Meten`)
};

const fr_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quotidien & Mesure`)
};

const it_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i giorni e misure`)
};

const pt_br2_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia a Dia e Medidas`)
};

const pt_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dia a Dia & Medidas`)
};

const ja_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常・計測`)
};

const zh_cat_everyday_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日常与测量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_everyday_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_everyday_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_everyday_name", locale)
	if (locale === "en") return en_cat_everyday_name(inputs)
	if (locale === "es") return es_cat_everyday_name(inputs)
	if (locale === "de") return de_cat_everyday_name(inputs)
	if (locale === "nl") return nl_cat_everyday_name(inputs)
	if (locale === "fr") return fr_cat_everyday_name(inputs)
	if (locale === "it") return it_cat_everyday_name(inputs)
	if (locale === "pt-BR") return pt_br2_cat_everyday_name(inputs)
	if (locale === "pt") return pt_cat_everyday_name(inputs)
	if (locale === "ja") return ja_cat_everyday_name(inputs)
	return zh_cat_everyday_name(inputs)
};